// extracted by mini-css-extract-plugin
module.exports = {"backButton":"bluckUpload_backButton__1djVw","uploadingHeading":"bluckUpload_uploadingHeading__1TX4r","madatoryField":"bluckUpload_madatoryField__3IqJM"};